import React from 'react';
export var PopperContext = React.createContext({
  popper: null
});